import React from 'react';
import OrganizationMaintenanceIndex from './organization';
import Maintenanceindex from './MaintenanceIndex';
import useOrganization from '../../hooks/use-organization';

function Index() {
  const organizationInfo = useOrganization();
  return Boolean(organizationInfo?.id) ? (
    <OrganizationMaintenanceIndex />
  ) : (
    <Maintenanceindex />
  );
}

export default Index;
